import styled, { css } from 'styled-components';
import { Divider as D, Layout } from 'antd';

import { mediaSize, theme } from '../../styles';

const { Sider } = Layout;


export const Divider = styled(D)`  
  margin: 15px 0;
  background: ${props => props.theme.colors.borderSilverDark};
  opacity: 0.15;
`;

export const SidebarWrapper = styled(Sider)`
  flex: 0 0 230px !important;
  max-width: 230px !important;
  min-width: 230px !important;

  .sidebar-ant-dropdown {
    left: 192px !important;
    top: 50px !important;
  }

  width: 230px !important;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  background: ${theme.colors.darkColor};

  ${({ collapsed }) => collapsed
  && css`
    flex: 0 0 60px !important;
    width: 60px !important;
    max-width: 60px !important;
    min-width: 60px !important;

    .sidebar-ant-dropdown {
      left: 45px !important;
    }
  `};

  @media (max-width: ${mediaSize.desktop}) {
    ${({ isOpenMobile }) => isOpenMobile
    ? css`
        display: block;
        z-index: 400;
      `
    : css`
        display: none;
      `}
    }
`;



// WEBPACK FOOTER //
// ./src/components/sidebar/styled-components.js